module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_01.12055623.webp";